var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('DataTable',{attrs:{"title":"Admin Blog","fields":_vm.fields,"response":_vm.data},on:{"delete":_vm.deleteBlog,"create":_vm.createBlog,"edit_click":_vm.editClick}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }